import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { ActionBlock } from "../TopBar/styled";
import { useSelectedResources } from "../../hooks/useSelectedResources";

export const ResetResources: FC = () => {
  const { t } = useTranslation("catalog");
  const [, reset] = useSelectedResources();

  return <ActionBlock onClick={reset}>{t("reset")}</ActionBlock>;
};
